export default "__VITE_ASSET__K3PKY8s3__"